"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRecaptchaGoogle = require("react-recaptcha-google");
var _global = _interopRequireDefault(require("global"));
var _FormWrap = _interopRequireDefault(require("../../../../Form/FormWrap"));
var _Input = _interopRequireDefault(require("../../../../Form/Input"));
var _TelephoneInput = _interopRequireDefault(require("../../../../Form/TelephoneInput"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var _Alert = _interopRequireDefault(require("../../../../Alert/Alert"));
var _ComponentWrapper = _interopRequireDefault(require("../../../../helpers/ComponentWrapper"));
var _constants = require("../../../../constants");
var _hooks = require("../../../../../helpers/hooks");
var _analytics = require("../../../../../helpers/analytics");
var _Select = _interopRequireDefault(require("../../../../Form/Select"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TywBookACall = function TywBookACall() {
  var _useForm = (0, _hooks.useForm)({
      oid: '00D0Y000002IW98'
    }),
    formData = _useForm.formData,
    handleChange = _useForm.handleChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)({
      type: '',
      text: ''
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    notification = _useState4[0],
    setNotification = _useState4[1];
  var contactFormCaptcha = (0, _react.useRef)();
  var contactForm = (0, _react.useRef)();

  // we need this ref to store actual value of state because in verifyCallback
  // The callbacks will not be reactive - they will not re-run the instant state changes,
  // but they *will* see the current value whenever they do run
  var formDataRef = (0, _react.useRef)();
  formDataRef.current = formData;
  var onLoadRecaptcha = function onLoadRecaptcha(e) {
    if (e) {
      e.preventDefault();
      setLoading(true);
    }
    if (contactFormCaptcha && contactFormCaptcha.current) {
      contactFormCaptcha.current.reset();
      contactFormCaptcha.current.execute();
    }
  };
  var verifyCallback = function verifyCallback(recaptchaToken) {
    // Here you will get the final recaptchaToken!!!
    if (recaptchaToken) {
      var query = new URLSearchParams(formDataRef.current).toString();
      fetch("https://script.google.com/macros/s/AKfycbxsg7l7SD-V3jrjhuY_UOXXReqT4QpLr-bi0aKesZlIveDPwjo9uhnpkQb5sEWwu5-A4g/exec?".concat(query), {
        method: "POST",
        mode: 'no-cors',
        headers: {
          "Content-Type": "text/html; charset=utf-8"
        }
      }).then(function (res) {
        setLoading(false);
        setNotification({
          type: 'success',
          text: 'Message successfully sent!'
        });
      })["catch"](function (err) {
        setLoading(false);
        setNotification({
          type: 'error',
          text: 'Something went wrong! Please try again later.'
        });
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "margin-bottom-xs"
  }, "Leave your details"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-bottom-xs"
  }, "Want to book the trip of a lifetime for this year but don't know where to start? Drop your details below and we'll get in touch and get you on the water in no time."), /*#__PURE__*/_react["default"].createElement(_FormWrap["default"], {
    ref: contactForm,
    id: _analytics.GA4_TRIGGERS.BOOK_CALL_FORM_ID,
    onSubmit: onLoadRecaptcha,
    loading: loading
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    placeholder: "Name",
    name: "name",
    id: "name",
    label: "Name",
    type: "text",
    value: formData.name,
    onChange: handleChange,
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    name: "email",
    type: "email",
    id: "email",
    placeholder: "Email",
    label: "Email",
    value: formData.email,
    onChange: handleChange,
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_TelephoneInput["default"], {
    name: "phone",
    id: "phone",
    type: "phone",
    placeholder: "+XX Your phone number",
    label: "Tel",
    value: formData.phone,
    onChange: function onChange(number) {
      return handleChange({
        target: {
          value: number,
          name: 'phone'
        }
      });
    },
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    id: "preferred_contact_method",
    name: "preferred_contact_method",
    type: "text",
    placeholder: "Preferred contact method",
    label: "Preferred contact method",
    options: ['Phone Call', 'Email'].map(function (o) {
      return {
        value: o,
        text: o
      };
    }),
    value: formData.preferred_contact_method,
    onChange: handleChange
  }), !!notification.type && notification.type !== 'success' && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-y-md",
    type: "error",
    show: true,
    message: "Ooops! Something went wrong. Please try again later.",
    onClose: function onClose() {
      return setNotification({});
    }
  }), !!notification.text && notification.type === 'success' && /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({}, notification, {
    show: true
  })), notification.type === '' && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    text: loading ? 'Submitting...' : 'Submit',
    buttonType: _constants.BUTTON_TYPES.PRIMARY,
    buttonSize: "btn--md",
    className: "margin-bottom-md margin-top-md",
    fullWidth: true,
    disabled: loading
  }), /*#__PURE__*/_react["default"].createElement("small", {
    className: "d8-u-color-contrast-high"
  }, "This site is protected by reCAPTCHA and the Google", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://policies.google.com/privacy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, ' ', "Privacy Policy"), ' ', "and", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://policies.google.com/terms",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Service"), ' ', "apply."), _global["default"].grecaptcha ? /*#__PURE__*/_react["default"].createElement(_reactRecaptchaGoogle.ReCaptcha, {
    ref: contactFormCaptcha,
    size: "invisible",
    render: "explicit",
    sitekey: "6Lc9GsIUAAAAABpO3JLwFv9dmkC1lOQDNRzwGZ-0",
    onloadCallback: onLoadRecaptcha,
    verifyCallback: verifyCallback
  }) : null));
};
var _default = exports["default"] = TywBookACall;